var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.content.timeslot.label)+" "),_c('span',{staticClass:"chawget-msg-date"},[_vm._v(_vm._s(_vm.formatDate(_vm.date)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }